import { useContext, useMemo, useState } from "react";
import { USER_GROUPS } from "constants/roles";
import { AuthContext } from "contexts/authContext";
import { useAppDispatch } from "hooks/reduxHooks";
import { PatientRepository } from "repositories/PatientRepository";
import { StatusBall } from "components/StatusBall/StatusBall";
import { setLoading } from "store/PatientStore/patientSlice";
import { FloatingMenu } from "components/FloatingMenu/FloatingMenu";
import { getDates } from "../../../../../utils/helpers";
import { StatusENUM } from "types/common";
export const ClinicAssitantRow = ({
  user,
  style,
  isButtonDarkMode,
  setIsButtonDarkMode,
  setOpenDetailsModal,
}: {
  user: any;
  style: any;
  isButtonDarkMode: boolean;
  setIsButtonDarkMode: any;
  setOpenDetailsModal: any;
}) => {
  const authContext = useContext(AuthContext);
  const dispatch = useAppDispatch();
  const [currentUser, setCurrentUser] = useState(user);

  const { parsedDates: dates, lastInviteOlderThat1Week } = getDates(
    currentUser.profileInfo?.inviteDates
  );

  const handleReInvite = async (e: any) => {
    e.stopPropagation();
    dispatch(setLoading(true));
    await authContext.reSendClinicInvite(
      currentUser.profileInfo?.email,
      USER_GROUPS.PATIENT
    );
    const patientRepo = PatientRepository.getInstance();
    const inviteDates = currentUser.profileInfo.inviteDates || [];
    const newInviteDates = [
      ...inviteDates,
      new Date().toISOString().slice(0, 10),
    ];
    await patientRepo.updatePatient(currentUser._id, {
      inviteDates: newInviteDates,
      authStatus: "invited",
    });
    setCurrentUser({
      ...currentUser,
      profileInfo: {
        ...currentUser.profileInfo,
        authStatus: "invited",
        inviteDates: newInviteDates,
      },
    });
    dispatch(setLoading(false));
  };

  const isInviteExpired =
    lastInviteOlderThat1Week &&
    currentUser.profileInfo.authStatus === "invited";
  const options = useMemo(() => {
    const isRegistered =
      currentUser.profileInfo.authStatus === StatusENUM.registered;
    return isRegistered
      ? []
      : [
          {
            text: "Send another invite",
            handler: handleReInvite,
          },
        ];
  }, [currentUser.profileInfo.authStatus]);

  const getStatus = (capitalize?: boolean) => {
    const statusString = currentUser.profileInfo.authStatus || "";
    if (!statusString) {
      return "";
    }

    const statusStringParsed = isInviteExpired ? "expired" : statusString;

    if (capitalize) {
      const firstLeter = statusStringParsed.charAt(0)?.toUpperCase();
      const word = statusStringParsed.slice(1, statusStringParsed.length);
      return `${firstLeter}${word}`;
    } else {
      return statusStringParsed;
    }
  };

  return (
    <div
      style={{ display: "flex", alignItems: "center" }}
      aria-hidden="true"
      onClick={() => {
        setOpenDetailsModal(true);
      }}
    >
      <p
        style={{
          ...style,
          textAlign: "initial",
        }}
      >
        {currentUser?.profileInfo?.email}
      </p>

      <p style={{ ...style, display: "flex", flexDirection: "column" }}>
        {dates.map((date: string, index) => (
          <p key={date + index}>{date}</p>
        ))}
      </p>

      <div style={{ display: "flex", alignItems: "center" }}>
        <StatusBall status={getStatus()} />
        <p
          style={{
            ...style,
            textAlign: "initial",
          }}
        >
          {getStatus(true)}
        </p>
      </div>

      <FloatingMenu
        setIsEditButtonDarkMode={setIsButtonDarkMode}
        options={options}
        style={isButtonDarkMode ? { color: "white" } : {}}
      />
    </div>
  );
};
